import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

const banners = [
    './banner0.png',
    './banner1.png',
    './banner2.png',

    
    
];

export default function BannerCarousel() {
    return (
        <Swiper
            modules={[Autoplay]}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            loop
            className="w-full mt-24 md:mt-14"
        >
            {banners.map((src, index) => (
                <SwiperSlide key={index} className="flex justify-center">
                    <img
                        src={src}
                        alt={`Banner ${index + 1}`}
                        className="w-full h-auto object-contain"
                    />
                </SwiperSlide>
            ))}
        </Swiper>

    );
}
